import { apiFetch } from "./client";

export interface AgentApiKey {
  id: string;
  name: string;
  tokenPrefix: string;
  lastUsedAt: string | null;
  createdAt: string;
}

export interface AgentApiKeyCreated extends AgentApiKey {
  token: string;
}

export const agentKeysApi = {
  list: (agentId: string) =>
    apiFetch<AgentApiKey[]>(`/agents/${agentId}/keys`),

  create: (agentId: string, name: string) =>
    apiFetch<AgentApiKeyCreated>(`/agents/${agentId}/keys`, {
      method: "POST",
      body: JSON.stringify({ name }),
    }),

  revoke: (agentId: string, keyId: string) =>
    apiFetch<void>(`/agents/${agentId}/keys/${keyId}`, {
      method: "DELETE",
    }),
};
